import EmployeeSalaryBonusComponents from "../components/EmployeeSalaryBonus";
import useEmployeeSalaryBonus from "../hooks/useEmployeeSalaryBonus";

function EmployeeSalaryBonus() {
  const employeeSalaryBonusProps = useEmployeeSalaryBonus();
  return <EmployeeSalaryBonusComponents {...employeeSalaryBonusProps} />;
}

export default EmployeeSalaryBonus;
